import React from 'react';
import styles from './StudentsWorks.module.css';


// Import your images
import result1 from "../../images/אסתר עבודות של תלמידות 1.png";
import result2 from "../../images/אסתר עבודות של תלמידות 2.png";
import result3 from "../../images/אסתר עבודות של תלמידות 3.png";

import result5 from "../../images/אסתר עבודות של תלמידות 5.png";
import result6 from "../../images/אסתר עבודות של תלמידות 6.png";
import result7 from "../../images/אסתר עבודות של תלמידות 7.png";
import result8 from "../../images/אסתר עבודות של תלמידות 8.png";

import result10 from "../../images/אסתר עבודות של תלמידות 10.png";
import result11 from "../../images/אסתר עבודות של תלמידות 11.png";
import result12 from "../../images/אסתר עבודות של תלמידות 12.png";
import result13 from "../../images/אסתר עבודות של תלמידות 13.png";
import result14 from "../../images/אסתר עבודות של תלמידות 14.png";

import result17 from "../../images/אסתר עבודות של תלמידות 17.png";
import result18 from "../../images/אסתר עבודות של תלמידות 18.png";
import result19 from "../../images/אסתר עבודות של תלמידות 19.png";
import result20 from "../../images/אסתר עבודות של תלמידות 20.png";
import result21 from "../../images/אסתר עבודות של תלמידות 21.png";
import result22 from "../../images/אסתר עבודות של תלמידות 22.png";
import result23 from "../../images/אסתר עבודות של תלמידות 23.png";
import Button from '../button/Button';


const StudentWorks = () => {
  const images = [
    result1, result2, result3,  result5, result6, result7, result8, 
   result10, result11, result12, result13, result14, 
    result17, result18, result19, result20, result21,result22,result23,
  ];

  return (
    <>
      <div className={styles.explain}>
והתלמידות שלי מוציאות עבודות כאלה <strong>כבר בזמן הקורס!</strong> (xs - 5xl):
      </div>

   
      <div className={styles.container}>
        <div className={styles.scrollTrack}>
          {/* קבוצה ראשונה של תמונות */}
          <div className={styles.scrollContainer}>
            {images.map((img, index) => (
              <div key={`first-${index}`} className={styles.imageWrapper}>
                <img
                  src={img}
                  alt={`המלצה ${index + 1}`}
                  className={styles.image}
                />
              </div>
            ))}
          </div>
          {/* קבוצה שנייה זהה של תמונות */}
          <div className={styles.scrollContainer}>
            {images.map((img, index) => (
              <div key={`second-${index}`} className={styles.imageWrapper}>
                <img
                  src={img}
                  alt={`המלצה ${index + 1}`}
                  className={styles.image}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

    </>
  );
};

export default StudentWorks;